import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Chat from './frontend/chat';
import Home from './frontend/Home';
import Signup from './frontend/Signup';
import Login from './frontend/Login';
import ForgotPassword from './frontend/forgot';





function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/chat/:username" element={<Chat />} /> 
         <Route path="/forgot" element={<ForgotPassword />} />  
      </Routes>
    </Router>
  );
}

export default App;



